import 'regenerator-runtime/runtime';

import React from 'react';

import Recommender from 'pages/offers/component/Accommodation/Recommender';

import { CommunicationProvider } from 'utility/Provide/Context/PageContext';
import ProviderWrapper from 'utility/Provide/Wrapper';

import styles from './OfferEntry.module.scss';

export default function OfferEntry() {
    return (
        <ProviderWrapper>
            <CommunicationProvider>
                <Recommender
                    classListObject={{
                        RecommenderWrapper: styles.Wrapper,
                    }}
                    withHeaderLink
                />
            </CommunicationProvider>
        </ProviderWrapper>
    );
}
